export const EXPLANATION_INFO = [
  {
    title: "円筒分水広場について",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "本当に現代に戻ってこれたんだね！なんだか不思議な気分…",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: "おかえり！謎を解くと現代に戻れるんだ。",
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "ここは円筒分水広場っていう名前なんだね！ところで、円筒分水って何だろう？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: "円筒分水は、多摩川の水を正確に分けるための仕組みなんだよ。",
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "へぇ～、そんな役割があるんだ！",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "この広場は高津区がまちおこしの一環として整備した場所で、屋根も円筒分水をイメージしたデザインになっているんだ。",
          "観光案内も設置されていて、今ではまちのシンボルとして親しまれているよ。"
        ].join('\n'),
      }
    ],
  },
  {
    title: "ポレポレタウンって何？",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "謎を解いたから、現代に戻ってこれたのかな？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "そうだよ！現代の商店街である『ポレポレタウン』に戻ってきたんだ。",
          "ストリートの名前は募集されて、約1,100通の応募の中から『ポレポレタウン』が満場一致で選ばれたんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "なんだかユニークな名前に決まったね。『ポレポレタウン』ってどういう意味？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "『ポレポレ』はスワヒリ語で『ゆっくり』『のんびり』って意味なんだ。アフリカ東海岸で使われている言葉だよ。",
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "たくさんお店があってにぎやかだね！",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "ここには100店舗以上の専門店が並んでいて、いつも活気にあふれているよ。",
          "『ポレポレまつり』やフリーマーケットなどのイベントもあって、今も昔も地元の人たちに愛されている商店街なんだ。"
        ].join('\n'),
      }
    ]
  },
  {
    title: "溝の口神社について",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "境内にはこんな多くの木があるんだね。",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: "そうだよ。境内には長寿ケヤキなどの大きな木が残っていて、自然も感じられる場所なんだ。",
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "この神社、どんなご利益があるの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "溝の口神社は『安産・子育て・縁結び・家内安全』などのご利益で有名なんだ。",
          "『川崎の祈願所』として、地元の人たちに親しまれているよ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "門をくぐると右手にある水場、ちょっと変わってる？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: "あれは手水舎（ちょうずや）だよ。4体の童子が水盤を支えている珍しいデザインなんだ。",
      }
    ]
  }, 
  {
    title: "灰吹屋の歴史",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "灰吹屋って、すごく歴史がありそうなお店だね。",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "そうだよ！灰吹屋の創業は江戸時代中期、今から250年以上も前なんだ。",
          "もともとは東京・四谷で“萬屋”として始まり、のちに溝口で薬種店を開いたのが始まりなんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "そんなに昔から続いているんだ！",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "江戸時代には『灰吹屋の生薬はよく効く』って評判で、遠くからもお客さんが来ていたんだ。",
          "三代目の店主は俳句もたしなんでいて、溝口の宗隆寺には芭蕉の句碑もあるんだよ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "お店の蔵も有名なんだよね？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "うん、八代目の店主が建てた蔵は今も残っていて、大山街道のランドマークになっているよ。",
          "今では倉庫として使われているけど、灰吹屋の歴史を感じられる建物なんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "今も地元で愛されているお店なんだね！",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: "そうだよ。江戸時代から続く伝統を大切にしながら、今も溝口で地域の人たちに親しまれているドラッグストアなんだ。",
      }
    ]
  },
  {
    title: "二ヶ領用水と溝の口の歴史",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "橋の下の「二ヶ領用水」ってどんな水路なの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "二ヶ領用水（にかりょうようすい）は、川崎市を北西から南東へ流れる全長約32kmの人工用水路なんだ。",
          "多摩川を水源にして、神奈川県下で最も古い用水路として知られているよ。",
          "昔は主に農業用水として使われていて、田んぼや畑に水を届ける大切な役割を担っていたんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "昔からこのあたりにあったの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "江戸時代には、この用水を渡るための大きな石橋が溝の口にいくつもあったんだ。",
          "今も残る大石橋はその名残で、当時は脇街道の『溝の口・二子宿』としてとても賑わっていたんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "今も溝の口がにぎやかなのは、その歴史があるからなんだね！",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "そうだよ。駅から二ヶ領用水沿いを北西に歩いていくと、昔の面影や自然も感じられるスポットがいろいろあるから、ぜひ歩いてみてほしい！"
        ].join('\n'),
      }
    ]
  },
  {
    title: "久地円筒分水と二ヶ領用水の工夫",
    conversation: [
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "二ヶ領用水って、どうやって水を分けていたの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "江戸時代、二ヶ領用水は多摩川から2か所で取水して、高津区久地で合流した後、久地分量樋（くじぶんりょうひ）で4つの堀に分けていたんだ。",
          "でも、昔は水門で分けていたから、なかなか正確に分水できず、水争いも絶えなかったんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "今はどうやって分けているの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "昭和16年（1941年）に『久地円筒分水（くじえんとうぶんすい）』が造られたんだ。",
          "円筒の円周比で水を4つの堀に正確に分けられるようになって、水争いもなくなったんだ。"
        ].join('\n'),
      },
      {
        name: "あなた",
        imageSrc: "/icon/man.png",
        message: "円筒分水って有名なの？",
      },
      {
        name: "のくち",
        imageSrc: "/icon/cat.png",
        message: [
          "久地円筒分水は国の登録有形文化財にもなっていて、全国の円筒分水のモデルにもなったんだ。",
          "用水の両側には春になると桜やいろんな花が咲いて、とってもきれいだよ！"
        ].join('\n'),
      }
    ]
  }
  // 他の目印データ...
];